import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { PulseLoader } from "react-spinners";
import { UsersListApi } from "../redux/actions/User/UserListAction";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Table from "../components/Table";
import { GetProductsApi } from "../redux/actions/Product/GetProductsAction";
import { GetNewsAndEventsApi } from "../redux/actions/NewsAndEvents/GetListAction";
import { GetCategoriesListApi } from "../redux/actions/Content/GetCategoriesList";
import { GetCategoriesApi } from "../redux/actions/Content/GetCategoriesAction";
import { GetFoodCategoriesApi } from "../redux/actions/Content/GetFoodCategoriesAction"
import { GetProductTypesApi } from "../redux/actions/Content/GetProductTypesAction";
import { GetQueriesApi } from "../redux/actions/Queries/GetQueriesAction";
import { OrdersListApi } from "../redux/actions/Order/GetOrderListAction";
import { clearOrderResponse } from "../redux/slices/Order/GetOrderList";
import { GetUnitsListContentApi } from "../redux/actions/Content/GetUnitsListContentAction";
import { GetReportsApi } from "../redux/actions/Queries/GetReportsAction";
import { UpdateStatusTerm } from "../redux/slices/Filters/StatusSlice";
import { GetMenuApi } from "../redux/actions/Menu/GetListAction";
import {
  CountrySelect,
  StateSelect,
  CitySelect
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { RegisterSupplierAPI } from "../redux/actions/Supplier/RegisterSupplierAction";
import { registerSupplierStateReset } from "../redux/slices/Supplier/RegisterSupplierSlice";
import { showErrorToast, showSuccessToast } from "../helpers/SweetAlert";

const Management = ({
  tab,
  foodCategoriesFetch,
  categoriesFetch,
  productTypeFetch,
  unitsFetch,
  role,
  supplierType,
  handleEditClick
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const previousSupplierTypeRef = useRef();
  console.log(tab, "<<<<<<<<<<<<<<<tab")
  const [currentPage, setCurrentPage] = useState(1);
  console.log(currentPage, "currentPageee");
  const [totalPages, setTotalPages] = useState(1);
  const [items, setItems] = useState(5);
  // const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(5);

  const [isToggled, setIsToggled] = useState(false);

  const [deleted, setDeleted] = useState(false);
  const [deletedMenu, setDeletedMenu] = useState(false);
  const [deletedQuery, setDeletedQuery] = useState(false);
  const [deletedReports, setDeletedReports] = useState(false);
  const [deletedNewsAndEvents, setDeletedNewsAndEvents] = useState(false);
  const { foodCategories } = useSelector((state) => state.foodCategories);
  const [deletedFoodCategories, setDeletedFoodCategories] = useState(false);


  const [validationErrors, setValidationErrors] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState(null);
  const [countryName, setCountryName] = useState(null);
  const [state, setState] = useState(null);
  const [stateName, setStateName] = useState(null);
  const [streetAddress, setStreetAddress] = useState('');
  const [city, setCity] = useState(null);
  const [cityName, setCityName] = useState(null);
  const [zipCode, setZipCode] = useState('');
  const [productType, setProductType] = useState('');
  // const [filtersReset, setFiltersReset] = useState(false);
  const { loading, response, error } = useSelector((state) => state.usersList);
  const { loading: productTypeLoading, response: productTypeResponse, error: productTypeError } = useSelector((state) => state.getProductTypeRegister);
  const { loading: supplierRegisterationLoading, response: supplierRegisterationResponse, error: supplierRegisterationError } = useSelector((state) => state.registerSupplier);
  const dayTerm = useSelector((state) => state.day.term);

  console.log(country, "country")
  const {
    response: getProductsResponse,
    error: getProductsError,
    loading: getProductsLoading,
  } = useSelector((state) => state.productManagement);
  const {
    response: getNewsAndEventsResponse,
    error: getNewsAndEventsError,
    loading: getNewsAndEventsLoading,
  } = useSelector((state) => state.newsAndEventsList);
  const {
    response: getMenuResponse,
    error: getMenuError,
    loading: getMenuLoading,
  } = useSelector((state) => state.menuList);
  const {
    response: getContentCategoriesResponse,
    error: getContentCategoriesError,
    loading: getContentCategoriesLoading,
  } = useSelector((state) => state.categories);
  const {
    response: getContentFoodCategoriesResponse,
    error: getContentFoodCategoriesError,
    loading: getContentFoodCategoriesLoading,
  } = useSelector((state) => state.foodCategories);
  const {
    response: getContentProductTypesResponse,
    error: getContentProductTypesError,
    loading: getContentProductTypesLoading,
  } = useSelector((state) => state.productTypes);
  const {
    response: getContentUnitsResponse,
    error: getContentUnitsError,
    loading: getContentUnitsLoading,
  } = useSelector((state) => state.getUnitsListContent);
  const {
    response: getQueriesResponse,
    error: getQueriesError,
    loading: getQueriesLoading,
  } = useSelector((state) => state.getQueries);
  const {
    response: getReportsResponse,
    error: getReportsError,
    loading: getReportsLoading,
  } = useSelector((state) => state.getReports);
  const {
    response: getOrdersResponse,
    error: getOrdersError,
    loading: getOrdersLoading,
  } = useSelector((state) => state.getOrdersList);

  const searchTerm = useSelector((state) => state.search.term);
  const statusTerm = useSelector((state) => state.status.term);
  console.log(getContentCategoriesResponse, getContentFoodCategoriesResponse, "<<<<<<<<<<<<<<<")

  const fetchUsersList = useCallback(() => {
    let role;
    switch (location.pathname) {
      case "/admin-dashboard/customer-management":
        role = "customer";
        break;
      case "/admin-dashboard/suppliers-management":
        role = "supplier";
        break;
      case "/admin-dashboard/restaurants-management":
        role = "restaurant";
        break;
      default:
        role = "Admin"; // fallback role if none match
    }

    dispatch(UsersListApi(currentPage, limit, role, searchTerm, statusTerm));
  }, [currentPage, limit, searchTerm, statusTerm, dispatch, location.pathname]);

  const fetchProducts = useCallback(() => {
    dispatch(GetProductsApi(searchTerm, currentPage, limit, statusTerm));
  }, [
    currentPage,
    limit,
    searchTerm,
    statusTerm,
    dispatch,
    deleted,
    location.pathname,
  ]);

  const fetchNewsAndEvents = useCallback(() => {
    dispatch(GetNewsAndEventsApi(currentPage, limit, statusTerm, searchTerm));
  }, [
    dispatch,
    currentPage,
    limit,
    statusTerm,
    searchTerm,
    location.pathname,
    tab,
  ]);

  const fetchMenu = useCallback(() => {
    const page = currentPage || 1;
    dispatch(GetMenuApi(page, limit, statusTerm, searchTerm, dayTerm));
  }, [
    dispatch,
    currentPage,
    limit,
    statusTerm,
    searchTerm,
    dayTerm,
    location.pathname,
  ]);

  const fetchContentCategories = useCallback(() => {
    dispatch(GetCategoriesApi(currentPage, limit, statusTerm, searchTerm));
  }, [
    dispatch,
    currentPage,
    limit,
    statusTerm,
    searchTerm,
    location.pathname,
    tab,
    categoriesFetch,
  ]);

  const fetchContentFoodCategories = useCallback(() => {
    dispatch(GetFoodCategoriesApi(currentPage, limit, statusTerm, searchTerm));
  }, [
    dispatch,
    currentPage,
    limit,
    statusTerm,
    searchTerm,
    location.pathname,
    tab,
    foodCategoriesFetch,
  ]);

  const fetchContentProductTypes = useCallback(() => {
    dispatch(GetProductTypesApi(currentPage, limit, statusTerm, searchTerm));
  }, [
    dispatch,
    currentPage,
    limit,
    statusTerm,
    searchTerm,
    location.pathname,
    tab,
    productTypeFetch,
  ]);

  const fetchContentUnits = useCallback(() => {
    dispatch(GetUnitsListContentApi(limit, currentPage));
  }, [dispatch, location.pathname, limit, currentPage, tab, unitsFetch]);

  const fetchQueries = useCallback(
    (t) => {
      if (t === "contact") {
        dispatch(GetQueriesApi(currentPage, limit));
      }
      if (t === "reports") {
        dispatch(GetReportsApi(currentPage, limit, statusTerm, searchTerm));
      }
    },
    [
      dispatch,
      currentPage,
      limit,
      isToggled,
      location.pathname,
      tab,
      statusTerm,
      searchTerm,
    ]
  );

  const validateForm = () => {
    const newErrors = {};

    if (!firstName || firstName.trim() === '') newErrors.firstName = true;
    if (!lastName || lastName.trim() === '') newErrors.lastName = true;

    if (!phoneNumber || phoneNumber.length < 10) newErrors.phone = true;

    if (!email || email.trim() === '') {
      newErrors.email = "required";
    } else {
      // Regex to check valid email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        newErrors.email = "invalid";
      }
    }

    if (!country) newErrors.country = true;
    if (!state) newErrors.state = true;
    if (!city) newErrors.city = true;
    if (!streetAddress || streetAddress.trim() === '') newErrors.streetAddress = true;
    if (!zipCode || zipCode.trim() === '') newErrors.zipCode = true;
    if (!productType) newErrors.productType = true;

    setValidationErrors(newErrors);

    return Object.keys(newErrors).length === 0; // true if no errors
  };

  const fetchOrders = useCallback(
    (userType) => {
      if (userType == 1) {
        dispatch(
          OrdersListApi(
            userType,
            currentPage,
            limit,
            searchTerm,
            statusTerm,
            supplierType
          )
        );
      } else {
        dispatch(OrdersListApi(userType, currentPage, limit));
      }
    },
    [
      dispatch,
      currentPage,
      limit,
      location.pathname,
      role,
      searchTerm,
      statusTerm,
      supplierType,
    ]
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const dataMap = useMemo(
    () => ({
      "/admin-dashboard/customer-management": {
        title: "Customer",
        tableData: response?.data,
        columns: [
          "Customer Name",
          "Total Purchases",
          "Country",
          "Email",
          "Status",
          "Action",
        ],
      },
      "/admin-dashboard/suppliers-management": {
        title: "Supplier's",
        tableData: response?.data,
        columns: [
          "Supplier Name",
          "Total Product",
          "Country",
          "Email",
          "Status",
          "Action",
        ],
      },
      "/admin-dashboard/restaurants-management": {
        title: "Restaurants",
        tableData: response?.data,
        columns: [
          "Restaurants Name",
          "Total Purchases",
          "Country",
          "Email",
          "Status",
          "Action",
        ],
      },
      "/admin-dashboard/product-management": {
        title: "Products",
        tableData: getProductsResponse?.data,
        columns: ["Product Name", "Category", "Type", "Status", "Action"],
      },
      "/admin-dashboard/news-and-events-management": {
        title: "News And Events",
        tableData: getNewsAndEventsResponse?.data,
        columns: ["Title", "Description", "Status", "Action"],
      },
      "/admin-dashboard/menu-management": {
        title: "Menu",
        tableData: getMenuResponse?.data
          ? {
            ...getMenuResponse.data,
            list: getMenuResponse.data.list?.map((menu) => ({
              ...menu,
              // Transform number to readable text for display
              category: menu.category === 0 ? "Veg" : "Non-Veg",
              day:
                menu.day === 0
                  ? "Monday"
                  : menu.day === 1
                    ? "Tuesday"
                    : menu.day === 2
                      ? "Wednesday"
                      : menu.day === 3
                        ? "Thursday"
                        : menu.day === 4
                          ? "Friday"
                          : menu.day === 5
                            ? "Saturday"
                            : "Sunday",
            })),
          }
          : null,
        columns: ["Food Name", "Food Type", "Price", "Day", "Action"],
      },

      "/admin-dashboard/content-management":
        tab === "categories"
          ? {
            title: "Categories",
            tableData: getContentCategoriesResponse?.data,
            columns: ["Category Name", "Units", "Status", "Action"],
          }
          : tab === "foodCategories"
            ? {
              title: "Food Category",
              tableData: getContentFoodCategoriesResponse?.data,
              columns: ["Food Category Name", "Status", "Action"],
            }
            : tab === "productTypes"
              ? {
                title: "Product Types",
                tableData: getContentProductTypesResponse?.data,
                columns: ["Type", "Status", "Action"],
              }
              : {
                title: "Units",
                tableData: getContentUnitsResponse?.data,
                columns: ["Name", "Status", "Action"],
              },
      "/admin-dashboard/queries-management":
        tab === "contact"
          ? {
            title: "Queries",
            tableData: getQueriesResponse?.data,
            columns: ["Name", "User Type", "Email", "Status", "Action"],
          }
          : tab === "reports"
            ? {
              title: "Queries",
              tableData: getReportsResponse?.data,
              columns: ["Name", "User Type", "Email", "Status", "Action"],
            }
            : {},
      "/admin-dashboard/order-management": {
        title: "Orders",
        tableData: getOrdersResponse?.data,
        columns: [
          "Name",
          "Total Products Ordered",
          "Delivery Date",
          "Status",
          "Action",
        ],
      },
    }),
    [
      response,
      getProductsResponse,
      getNewsAndEventsResponse,
      getMenuResponse,
      getContentCategoriesResponse,
      getContentFoodCategoriesResponse,
      getReportsResponse,
      getContentUnitsResponse,
      getContentProductTypesResponse,
      getQueriesResponse,
      getOrdersResponse,
      supplierType,
      tab,
      categoriesFetch,
      productTypeFetch,
      role,
    ]
  );

  const currentData = useMemo(
    () => dataMap[location.pathname] || { title: "Default", tableData: [] },
    [dataMap, location.pathname]
  );


  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setPhoneNumber("");
    setEmail("");
    setCountry("");
    setCountryName("");
    setState("");
    setStateName("");
    setCity("");
    setCityName("");
    setStreetAddress("");
    setZipCode("");
    setProductType("");
    setValidationErrors({});
  };

  const handleAddNewSupplier = async () => {
    if (!validateForm()) {
      // Stop submission if validation fails
      return;
    }

    try {
      await dispatch(RegisterSupplierAPI({ role: 'supplier', firstName, lastName, email, phoneNumber, state: stateName, city: cityName, street: streetAddress, country: countryName, zipCode, registeredBy: 'Admin', product: productType }))
    } catch (error) {
      console.log(error, "Error")
    }
  };

  useEffect(() => {
    dispatch(UpdateStatusTerm(""));
  }, [location.pathname]);

  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/menu-management" ||
      location.pathname === "/admin-dashboard/customer-management" ||
      location.pathname === "/admin-dashboard/suppliers-management" ||
      location.pathname === "/admin-dashboard/restaurants-management" ||
      location.pathname === "/admin-dashboard/product-management" ||
      location.pathname === "/admin-dashboard/news-and-events-management" ||
      location.pathname === "/admin-dashbaord/content-management" ||
      location.pathname === "/admin-dashboard/queries-management" ||
      location.pathname === "/admin-dashboard/order-management"
    ) {
      setLimit(5);
      setCurrentPage(1);
      // setFiltersReset(true);
    }
  }, [dayTerm, location.pathname]);

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement) {
      // Add event listener for when modal hides
      modalElement.addEventListener("hidden.bs.modal", clearForm);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", clearForm);
      }
    };
  }, []);

  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/customer-management" ||
      location.pathname === "/admin-dashboard/suppliers-management" ||
      location.pathname === "/admin-dashboard/restaurants-management"
    ) {
      fetchUsersList();
    }
    // if (location.pathname === '/admin-dashboard/product-management') {
    //     fetchProducts();
    // }
  }, [searchTerm, statusTerm, limit, currentPage, location, fetchUsersList]);

  const fetchFoodCategories = () => {
    dispatch(GetFoodCategoriesApi(currentPage, limit, statusTerm, searchTerm));
  };

  useEffect(() => {
    fetchFoodCategories();
  }, [currentPage]);

  useEffect(() => {
    if (deletedFoodCategories) {
      fetchFoodCategories();
      setDeletedFoodCategories(false);
    }
  }, [deletedFoodCategories]);


  useEffect(() => {
    if (location.pathname === "/admin-dashboard/product-management") {
      fetchProducts();
    }
  }, [
    searchTerm,
    statusTerm,
    limit,
    currentPage,
    location,
    fetchProducts,
    deleted,
  ]);

  useEffect(() => {
    if (location.pathname === "/admin-dashboard/news-and-events-management") {
      fetchNewsAndEvents();
    }
  }, [
    location,
    limit,
    currentPage,
    fetchNewsAndEvents,
    statusTerm,
    searchTerm,
    deletedNewsAndEvents,
  ]);

  useEffect(() => {
    if (location.pathname === "/admin-dashboard/menu-management") {
      fetchMenu();
    }
  }, [
    location,
    limit,
    currentPage,
    fetchMenu,
    statusTerm,
    searchTerm,
    deletedMenu,
  ]);

  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/content-management" &&
      tab == "categories"
    ) {
      fetchContentCategories();
    }
  }, [
    location.pathname,
    limit,
    currentPage,
    statusTerm,
    searchTerm,
    fetchContentCategories,
    categoriesFetch,
  ]);

  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/content-management" &&
      tab == "foodCategories"
    ) {
      fetchContentFoodCategories();
    }
  }, [
    location.pathname,
    limit,
    currentPage,
    statusTerm,
    searchTerm,
    fetchContentFoodCategories,
    foodCategoriesFetch,
  ]);


  console.log(productTypeResponse, "productTypeResponse")
  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/content-management" &&
      tab == "productTypes"
    ) {
      fetchContentProductTypes();
    }
  }, [
    location.pathname,
    limit,
    currentPage,
    statusTerm,
    searchTerm,
    fetchContentProductTypes,
    productTypeFetch,
  ]);

  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/content-management" &&
      tab == "units"
    ) {
      fetchContentUnits();
    }
  }, [location.pathname, fetchContentUnits, limit, currentPage, unitsFetch]);

  useEffect(() => {
    if (location.pathname === "/admin-dashboard/queries-management") {
      if (tab == "contact") {
        fetchQueries("contact");
      }
      if (tab == "reports") {
        fetchQueries("reports");
      }
    }
  }, [
    limit,
    currentPage,
    location.pathname,
    fetchQueries,
    tab,
    isToggled,
    deletedQuery,
    deletedReports,
  ]);

  useEffect(() => {
    if (supplierRegisterationResponse?.status === true) {
      dispatch(registerSupplierStateReset());
      showSuccessToast(supplierRegisterationResponse?.message);
      clearForm();
      if (modalRef.current) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current); // get existing instance
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    }
  }, [supplierRegisterationResponse])

  useEffect(() => {
    if (supplierRegisterationError) {
      showErrorToast(supplierRegisterationError?.data);
    }
  }, [supplierRegisterationResponse])
  useEffect(() => {
    if (
      location.pathname === "/admin-dashboard/order-management" &&
      role == "supplier"
    ) {
      fetchOrders(1);
    }
    if (
      location.pathname === "/admin-dashboard/order-management" &&
      role == "customer"
    ) {
      fetchOrders(2);
    }
    if (
      location.pathname === "/admin-dashboard/order-management" &&
      role == "restaurant"
    ) {
      fetchOrders(3);
    }
  }, [
    limit,
    currentPage,
    location,
    role,
    fetchOrders,
    supplierType,
    searchTerm,
    statusTerm,
  ]);

  // // Reset pagination when supplierType changes
  // useEffect(() => {
  //     if (location.pathname === '/admin-dashboard/order-management' && role === 'supplier') {
  //         setCurrentPage(1);
  //         setLimit(5);
  //     }
  // }, [supplierType, location.pathname, role]);

  useEffect(() => {
    if (currentData?.tableData) {
      setCurrentPage(currentData?.tableData?.currentPage);
      setTotalPages(currentData?.tableData?.totalPages);
      setItems(currentData?.tableData?.totalItems);
    }
  }, [currentData?.tableData]);
  return (
    <>
      {getProductsLoading ||
        loading ||
        getNewsAndEventsLoading ||
        getContentCategoriesLoading ||
        getContentFoodCategoriesLoading ||
        getContentProductTypesLoading ||
        getQueriesLoading ||
        getOrdersLoading ||
        getContentUnitsLoading ||
        getReportsLoading ||
        getMenuLoading ? (
        <div
          style={{ height: "70vh" }}
          className="d-flex align-items-center justify-content-center"
        >
          <PulseLoader size={25} color="#0f0a30" />
        </div>
      ) : error ||
        getProductsError ||
        getNewsAndEventsError ||
        getContentCategoriesError ||
        getContentFoodCategoriesError ||
        getContentProductTypesError ||
        getQueriesError ||
        getOrdersError ||
        getContentUnitsError ||
        getReportsError ||
        getMenuError ? (
        <div
          style={{ height: "70vh" }}
          className="d-flex align-items-center justify-content-center"
        >
          <p className="text-danger">Something went wrong</p>
        </div>
      ) : (
        <Table
          title={currentData.title}
          tableData={currentData.tableData}
          limit={limit}
          items={items}
          columns={currentData.columns}
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          tab={tab}
          role={role}
          fetchNewsAndEvents={fetchNewsAndEvents}
          setDeleted={setDeleted}
          setDeletedQuery={setDeletedQuery}
          setDeletedReports={setDeletedReports}
          setDeletedNewsAndEvents={setDeletedNewsAndEvents}
          statusTerm={statusTerm}
          setIsToggled={setIsToggled}
          setDeletedMenu={setDeletedMenu}
          setDeletedFoodCategories={setDeletedFoodCategories}
          fetchFoodCategories={fetchFoodCategories}
          handleEditClick={handleEditClick}

        />

      )}

      <div className="modal fade" id="addSupplierModal" tabIndex={-1} aria-labelledby="addSupplierModalLabel" aria-hidden="true" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-2 fw-bold text-black" id="addSupplierModalLabel">Add New Supplier</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => clearForm()} />
            </div>
            <div className="modal-body detail-modal-body">
              <div className='modal-field mb-2'>

                <div className="input_wrapper">
                  <label>First Name</label>
                  <div className="form_field">
                    <input type="text" className={`form-control ${validationErrors.firstName ? 'is-invalid' : ''}`}
                      placeholder="Enter name"
                      value={firstName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length === 1 && value === ' ') return;
                        setFirstName(value);
                        if (validationErrors.firstName) {
                          setValidationErrors(prev => ({ ...prev, firstName: false }));
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="input_wrapper">
                  <label>Last Name</label>
                  <div className="form_field">
                    <input type="text" className={`form-control ${validationErrors.lastName ? 'is-invalid' : ''}`}
                      placeholder="Enter name"
                      value={lastName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length === 1 && value === ' ') return;
                        setLastName(value);
                        if (validationErrors.lastName) {
                          setValidationErrors(prev => ({ ...prev, lastName: false }));
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="input_wrapper">
                  <label>Phone Number</label>
                  <PhoneInput
                    country={'in'} // default country
                    value={phoneNumber}
                    onChange={(value) => {
                      setPhoneNumber(value);

                      // validation
                      if (!value || value.length < 10) {
                        setValidationErrors(prev => ({ ...prev, phone: true }));
                      } else {
                        setValidationErrors(prev => ({ ...prev, phone: false }));
                      }
                    }}
                    inputStyle={{ width: "100%" }}
                    containerClass={`form-control ${validationErrors.phone ? "is-invalid" : ""}`}
                  />
                </div>
                <div className="input_wrapper">
                  <label>Email Address</label>
                  <div className="form_field">
                    <input type="text" className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
                      placeholder="Enter name"
                      value={email}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length === 1 && value === ' ') return;
                        setEmail(value);
                        if (validationErrors.email) {
                          setValidationErrors(prev => ({ ...prev, email: false }));
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="input_wrapper">
                  <label>Country</label>
                  <div className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}>
                    <CountrySelect
                      onChange={(e) => {
                        setCountry(e.id);
                        setCountryName(e.name);
                        if (validationErrors.country) {
                          setValidationErrors(prev => ({ ...prev, country: false }));
                        }
                      }}
                      placeHolder="Select Country"
                      className={`form-control ${validationErrors.country ? 'is-invalid' : ''}`}
                    />
                  </div>
                </div>

                <div className="input_wrapper">
                  <label>State</label>
                  <div className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}>
                    <StateSelect
                      countryid={country}
                      onChange={(e) => {
                        setState(e.id);
                        setStateName(e.name);
                        if (validationErrors.state) {
                          setValidationErrors(prev => ({ ...prev, state: false }));
                        }
                      }}
                      placeHolder="Select State"
                      className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}
                    />
                  </div>
                </div>

                <div className="input_wrapper">
                  <label>City</label>
                  <div className={`form-control ${validationErrors.state ? 'is-invalid' : ''}`}>
                    <CitySelect
                      countryid={country}
                      stateid={state}
                      onChange={(e) => {
                        setCity(e.id);
                        setCityName(e.name);
                        if (validationErrors.city) {
                          setValidationErrors(prev => ({ ...prev, city: false }));
                        }
                      }}
                      placeHolder="Select City"
                      className={`form-control ${validationErrors.city ? 'is-invalid' : ''}`}
                    />
                  </div>
                </div>

                <div className="input_wrapper">
                  <label>Street Address</label>
                  <div className="form_field">
                    <input type="text" className={`form-control ${validationErrors.streetAddress ? 'is-invalid' : ''}`}
                      placeholder="Enter name"
                      value={streetAddress}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length === 1 && value === ' ') return;
                        setStreetAddress(value);
                        if (validationErrors.streetAddress) {
                          setValidationErrors(prev => ({ ...prev, streetAddress: false }));
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="input_wrapper">
                  <label>Zip Code</label>
                  <div className="form_field">
                    <input type="text" className={`form-control ${validationErrors.zipCode ? 'is-invalid' : ''}`}
                      placeholder="Enter name"
                      value={zipCode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length === 1 && value === ' ') return;
                        setZipCode(value);
                        if (validationErrors.zipCode) {
                          setValidationErrors(prev => ({ ...prev, zipCode: false }));
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="input_wrapper">
                  <label>Type of Product supplier will sell</label>
                  <div className="form_field">
                    <select
                      className={`form-control ${validationErrors.productType ? 'is-invalid' : ''}`}
                      value={productType}
                      onChange={(e) => {
                        setProductType(e.target.value);
                        if (validationErrors.productType) {
                          setValidationErrors((prev) => ({ ...prev, productType: false }));
                        }
                      }}
                    >
                      {productTypeLoading ? (
                        <option value="">Loading...</option>
                      ) : productTypeError ? (
                        <option value="">No data</option>
                      ) : (
                        <>
                          <option value="">-- Select Product Type --</option>
                          {productTypeResponse?.data?.productType?.map((type) => (
                            <option key={type._id} value={type._id}>
                              {type.name}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>



              </div>
              <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                <button className='transparent-btn fs-14 py-2' data-bs-dismiss="modal">Cancel</button>
                <button className='primary-btn fs-14 py-2' onClick={handleAddNewSupplier}>{supplierRegisterationLoading ? <PulseLoader color="#ffffff" size={12} /> : 'Add New'}</button>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  )



};

export default Management;
